export default __webpack_public_path__ + "static/media/welcome.0b2ec606.svg";